import * as Common from '@/agiles/common';
import * as CatalogCommon from '@/tenantCatalog/common';

export enum CouponFlags {
  None = 0,
  PeriodExtension = 1,  // 期間延長
  Discount = 2, // 値引
  SafeIntroductionDiscount = 4, // あんしん導入パック値引
  InitialPriceDiscount = 10,  // 初期費用割引
}

export enum CouponState {
  None = 0,
  Usable = 1,  // 使用可
  Used = 2, // 使用済み
  Expired = 4, // 未使用・期限切れ
}

export class Coupon extends Common.StateObject{
    constructor(){
        super('Coupon');        
        this.workflowCode="approval";
        this.workflowStateId = Common.ApprovalStatus.NotApproved;
        this.state = Common.ApprovalStatus.NotApproved;
    }    
        public couponCode: string;
        public couponFlag: CatalogCommon.CouponFlags;
        public companyName: string;
        public picName: string;
        public mailAddress:string;
        public telNo:string;
        public discountAmount:number;
        public displayName:string;
        public expiry:Date;
        public usedTenantId:string;
        public get used():boolean {return this.usedTenantId ? true : false ;}

        public copy():any {
          const temp = super.copy() as Coupon;
          temp.couponCode = '';
          temp.expiry = null;
          temp.usedTenantId = null;
          return temp;
        }
}

export class CouponQuery extends Common.LoadQuery {
  constructor() {
    super('CouponQuery', Coupon);
    this.sort = 'displayOrder';
  }
  public usedTenantId:string;
  public companyName:string;
  public picName:string;
  public mailAddress:string;
  public couponFlag:CouponFlags;
  public couponState:CouponState;

}
